{
  "name": "@cnsa-fr/design-system",
  "version": "0.7.0",
  "author": "CNSA",
  "license": "MIT",
  "customElements": "dist/custom-elements.json",
  "web-types": "dist/web-types.json",
  "type": "module",
  "types": "dist/design-system.d.ts",
  "exports": {
    ".": {
      "types": "./dist/design-system.d.ts",
      "import": "./dist/design-system.js"
    },
    "./dist/custom-elements.json": "./dist/custom-elements.json",
    "./dist/themes/*": "./dist/themes/*",
    "./dist/assets/*": "./dist/assets/*",
    "./dist/components/*": "./dist/components/*",
    "./dist/utilities/*": "./dist/utilities/*",
    "./dist/translations/*": "./dist/translations/*"
  },
  "files": [
    "dist"
  ],
  "repository": {
    "directory": "packages/design-system",
    "type": "git",
    "url": "https://github.com/cnsa-fr/design-system.git"
  },
  "publishConfig": {
    "access": "restricted",
    "registry": "https://npm.pkg.github.com"
  },
  "storybook": {
    "url": "https://main--641b0785d6e1bb53ae448dc7.chromatic.com"
  },
  "scripts": {
    "start": "node scripts/build.js --bundle --serve",
    "build": "node scripts/build.js --bundle --types --copydir \"docs/dist\"",
    "ts-check": "tsc --noEmit --project ./tsconfig.json",
    "create": "plop --plopfile scripts/plop/plopfile.js",
    "test": "web-test-runner --group default",
    "test:coverage": "web-test-runner --group default --coverage",
    "test:component": "web-test-runner -- --watch --group",
    "test:watch": "web-test-runner --watch --group default",
    "list-outdated-dependencies": "npm-check-updates --format repo --peer",
    "update-dependencies": "pnpm-check-updates --peer -u && pnpm install",
    "storybook": "storybook dev -p 6006",
    "build-storybook": "storybook build"
  },
  "engines": {
    "node": ">=14.17.0"
  },
  "dependencies": {
    "@cnsa-fr/design-assets": "workspace:*",
    "@ctrl/tinycolor": "3.5.0",
    "@floating-ui/dom": "1.2.8",
    "@lit-labs/react": "1.1.1",
    "@shoelace-style/animations": "1.1.0",
    "@shoelace-style/localize": "3.1.0",
    "composed-offset-position": "0.0.4",
    "lit": "2.6.1",
    "qr-creator": "1.0.0"
  },
  "devDependencies": {
    "@cnsa-fr/eslint-config": "workspace:*",
    "@custom-elements-manifest/analyzer": "0.6.8",
    "@material-design-icons/svg": "0.14.4",
    "@open-wc/lit-helpers": "0.5.1",
    "@storybook/addon-a11y": "7.0.21",
    "@storybook/addon-actions": "7.0.21",
    "@storybook/addon-backgrounds": "7.0.21",
    "@storybook/addon-controls": "7.0.21",
    "@storybook/addon-docs": "7.0.21",
    "@storybook/addon-links": "7.0.21",
    "@storybook/addon-toolbars": "7.0.21",
    "@storybook/addon-viewport": "7.0.21",
    "@storybook/blocks": "7.0.21",
    "@storybook/manager-api": "7.0.21",
    "@storybook/theming": "7.0.21",
    "@storybook/web-components": "7.0.21",
    "@storybook/web-components-vite": "7.0.21",
    "@types/mocha": "10.0.1",
    "@types/react": "18.2.0",
    "@types/sinon": "10.0.13",
    "browser-sync": "2.27.11",
    "cem-plugin-vs-code-custom-data-generator": "1.4.1",
    "chalk": "5.2.0",
    "command-line-args": "5.2.1",
    "comment-parser": "1.3.1",
    "del": "7.0.0",
    "download": "8.0.0",
    "eslint-plugin-chai-expect": "3.0.0",
    "eslint-plugin-chai-friendly": "0.7.2",
    "eslint-plugin-import": "2.27.4",
    "eslint-plugin-lit": "1.8.2",
    "eslint-plugin-lit-a11y": "2.3.0",
    "eslint-plugin-markdown": "3.0.0",
    "eslint-plugin-wc": "1.4.0",
    "front-matter": "4.0.2",
    "get-port": "6.1.2",
    "globby": "13.1.3",
    "jsonata": "2.0.1",
    "lunr": "2.3.9",
    "npm-check-updates": "16.6.2",
    "pascal-case": "3.1.2",
    "plop": "3.1.1",
    "postcss": "8.4.23",
    "react": "18.2.0",
    "react-dom": "18.2.0",
    "recursive-copy": "2.0.14",
    "sinon": "15.0.1",
    "source-map": "0.7.4",
    "storybook": "7.0.21",
    "storybook-addon-pseudo-states": "2.0.1",
    "strip-css-comments": "5.0.0",
    "ts-dedent": "2.2.0",
    "tslib": "2.4.1",
    "user-agent-data-types": "0.3.0",
    "vite": "4.3.9",
    "vite-plugin-turbosnap": "1.0.2"
  }
}
